<template>
    <div class="index" id="boxFixed" :data-path="activeIndex">
      <el-scrollbar style="height: 100vh;" ref="myScrollbar" class="myScrollbar">
        <div :class="{'is_fixed' : isFixed}">
          <headerMain @goscrolltop="goScrollTop"></headerMain>
        </div>
        <div :style="'padding-top:' + ( isFixed ? 64 : 0 ) + 'px'" class="header_box">
          <appMain @goscrolltop="goScrollTop"></appMain>
          <footerMain></footerMain>
        </div>
      </el-scrollbar>
    </div>
</template>

<script>

import { headerMain, appMain, footerMain } from './components';
export default {
  name: 'Layout',
  components: {
    headerMain,
    appMain,
    footerMain
  },
  computed: {
    activeIndex () {
      const route = this.$route;
      const {path} = route;
      return path;
    }
  },
  data () {
    return {
      isFixed: false,
      offsetTop: 0
    };
  },
  mounted () {
    $('.myScrollbar > .el-scrollbar__wrap')[0].addEventListener('scroll', this.initHeight);
    this.$nextTick(() => {
      this.offsetTop = document.querySelector('#boxFixed').offsetTop;
    });
  },
  destroyed () {
    $('.myScrollbar > .el-scrollbar__wrap')[0].removeEventListener('scroll', this.initHeight);
  },
  methods: {
    goScrollTop () {
      this.$refs.myScrollbar.wrap.scrollTop = 0;
    },
    initHeight () {
      var scrollTop = $('.myScrollbar > .el-scrollbar__wrap')[0].scrollTop;
      this.isFixed = scrollTop > this.offsetTop;
    }
  }
};
</script>

<style lang="scss" scoped>
.index{
  height: 100vh;
  .is_fixed{
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 19900;
    min-width: 1440px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue